import axios from "axios";

const usePromptsProvider = () => {
  // Get Prompts lists
  const listPromptsProvider = (params) => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/ai-prompts`,
      params: params,
    });
  };

  // Get Prompt by id
  const getPromptProvider = (id) => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/ai-prompts/${id}`,
    });
  };

  // update Prompts by id
  const updatePromptProvider = (data) => {
    return axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}api/ai-prompts/${data.id}`,
      data,
    });
  };

  // Create Prompt
  const createPromptProvider = (data) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/ai-prompts`,
      data,
    });
  };

  // Remove Prompt
  const deletePromptProvider = (id) => {
    return axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}api/ai-prompts/${id}`,
    });
  };

  const getPromptCategoryProvider = () => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/ai-categories`,
    });
  };

  const createCategoryPromptProvider = (data) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/ai-categories`,
      data,
    });
  }

  return {
    listPromptsProvider,
    getPromptProvider,
    updatePromptProvider,
    createPromptProvider,
    deletePromptProvider,
    getPromptCategoryProvider,
    createCategoryPromptProvider
  };
};

export default usePromptsProvider;
